export default {
  regionalRiskAssessment: {
    eudrDueDiligence: "Uji Tuntas EUDR",
    title: "Penilaian Risiko Regional",
    titleTT: "Tolok ukur negara dalam penilaian risiko regional EUDR",
    details: "Detail",
    detailsTT: "Perluas untuk melihat kriteria rinci dan referensi terkait klasifikasi risiko tinggi, dengan fokus pada deforestasi, hak-hak adat, korupsi, dan isu-isu hak asasi manusia.",
    createNewCountryReport: "Buat Laporan Negara Baru",
    updateCountryReport: "Perbarui Laporan Negara",
    duplicateCountryReport: "Duplikasi Laporan Negara",
    search: "Cari",
    country: "Negara",
    dateCreated: "Tanggal Dibuat",
    edit: "Sunting",
    delete: "Hapus",
    duplicate: "Duplikasi",
    actions: "Tindakan",
    submit: "Kirim",
    save: "Simpan",
    cancel: "Batalkan",
    selectCountry: "Pilih Negara",
    riskAssessmentCriteria: "Kriteria Penilaian Risiko",
    riskLevel: "Tingkat Risiko",
    unassigned: "Belum Ditugaskan",
    standard: "Standar",
    standardToHigh: "Standar ke Tinggi",
    high: "Tinggi",
    reportDetails: "Detail Laporan",
    select: "Pilih",
    requiredFields: "Bidang ini wajib diisi",
    pleaseFillRequiredFields: "Harap isi semua bidang yang wajib diisi",
    createCuccess: "Penilaian risiko regional berhasil dibuat",
    updateSuccess: "Penilaian risiko regional berhasil diperbarui",
    createError: "Kesalahan dalam membuat penilaian risiko regional",
    updateError: "Kesalahan dalam memperbarui penilaian risiko regional",
    deleteSuccess: "Penilaian risiko regional berhasil dihapus",
    duplicateSuccess: "Penilaian risiko regional berhasil diduplikasi",
    deleteRegionalRisk: "Hapus Penilaian Risiko Regional",
    confirmDelete: "Apakah Anda yakin ingin menghapus penilaian risiko regional ini?",
    confirm: "Konfirmasi",
    saveSuccess: "Penilaian risiko regional berhasil disimpan",
    fetchError: "Kesalahan dalam mengambil penilaian risiko regional",
    disregard: "Abaikan Segmen",
    addRegionalRiskAssessment: "Tambah Penilaian Risiko Regional",
    summary: "Ringkasan",
    summaryTT: "Bagian ini menguraikan tingkat risiko yang diberikan berdasarkan data dan referensi yang komprehensif.",
    summaryText: "Penilaian risiko negara akan mengklasifikasikan negara perkebunan berdasarkan tingkat risiko berikut (Tinggi, Standar, dan Nol/Negligible) berdasarkan referensi yang dapat diverifikasi, informasi, dokumen, dan data. Hasil yang berbeda dari 'Nol/Negligible' akan menunjukkan perlunya tindakan mitigasi risiko (RMA) untuk memastikan 'Risiko Nol/Negligible'. Tabel 1 menunjukkan hasil keseluruhan dari penilaian risiko untuk (country). Penilaian risiko negara lengkap terlampir dalam dokumen ini di Lampiran III.",
    disregardConfirmTitle: "Abaikan Segmen Mana Saja atau Semua",
    selectSegment: "Pilih segmen untuk diabaikan.",
    addConfirmTitle: "Tambahkan Segmen Mana Saja atau Semua",
    deselectToAddSegment: "Batalkan pemilihan segmen untuk ditambahkan.",
    all: "Semua",
    protectedAreas: "Wilayah Terlindung & Adat",
    verificaton: "Verifikasi dengan Basis Data Pemerintah Brasil",
    confirmation: "Konfirmasi",
    confirmationMessage: "Apakah Anda yakin ingin mengabaikan penilaian risiko regional? Mengonfirmasi tindakan ini akan menghapus penilaian risiko regional dari laporan uji tuntas.",
    noSegmentSelectedMessage: "Tidak ada segmen yang dipilih. Silakan pilih segmen untuk melanjutkan.",
    singleRiskAssessmentCriteriaMessage: "Apakah Anda yakin ingin menambah atau menghapus Kriteria Penilaian Risiko Regional? Mengonfirmasi tindakan ini akan memperbarui laporan uji tuntas.",
    singleProtectedAreasMessage: "Apakah Anda yakin ingin menambah atau menghapus Wilayah yang Dilindungi dan Adat? Mengonfirmasi tindakan ini akan memperbarui laporan uji tuntas.",
    bothSegmentsMessage: "Apakah Anda yakin ingin menambah atau menghapus baik Kriteria Penilaian Risiko Regional maupun Wilayah yang Dilindungi dan Adat? Mengonfirmasi tindakan ini akan memperbarui laporan uji tuntas.",
    segmentsUpdatedSuccessfully: "Segmen berhasil diperbarui"
    }
  }
